import {
  FETCH_TRACKING_LINKS_START,
  FETCH_TRACKING_LINKS_SUCCESS,
  FETCH_TRACKING_LINKS_FAILED,
  CREATE_TRACKING_LINK_START,
  CREATE_TRACKING_LINK_SUCCESS,
  CREATE_TRACKING_LINK_FAILED,
  UPDATE_TRACKING_LINK_START,
  UPDATE_TRACKING_LINK_SUCCESS,
  UPDATE_TRACKING_LINK_FAILED,
  DELETE_TRACKING_LINK_START,
  DELETE_TRACKING_LINK_SUCCESS,
  DELETE_TRACKING_LINK_FAILED,
  TRACK_VIEW_TRACKING_LINK_START,
  TRACK_VIEW_TRACKING_LINK_SUCCESS,
  TRACK_VIEW_TRACKING_LINK_FAILED
} from "./ActionConstant";

// Fetch tracking links actions
export function fetchTrackingLinksStart(payload) {
  return {
    type: FETCH_TRACKING_LINKS_START,
    payload,
  };
}

export function fetchTrackingLinksSuccess(payload) {
  return {
    type: FETCH_TRACKING_LINKS_SUCCESS,
    payload,
  };
}

export function fetchTrackingLinksFailure(payload) {
  return {
    type: FETCH_TRACKING_LINKS_FAILED,
    payload,
  };
}

// Create tracking link actions
export function createTrackingLinkStart(payload) {
  return {
    type: CREATE_TRACKING_LINK_START,
    payload,
  };
}

export function createTrackingLinkSuccess(payload) {
  return {
    type: CREATE_TRACKING_LINK_SUCCESS,
    payload,
  };
}

export function createTrackingLinkFailure(payload) {
  return {
    type: CREATE_TRACKING_LINK_FAILED,
    payload,
  };
}

// Update tracking link actions
export function updateTrackingLinkStart(payload) {
  return {
    type: UPDATE_TRACKING_LINK_START,
    payload,
  };
}

export function updateTrackingLinkSuccess(payload) {
  return {
    type: UPDATE_TRACKING_LINK_SUCCESS,
    payload,
  };
}

export function updateTrackingLinkFailure(payload) {
  return {
    type: UPDATE_TRACKING_LINK_FAILED,
    payload,
  };
}

// Delete tracking link actions
export function deleteTrackingLinkStart(payload) {
  return {
    type: DELETE_TRACKING_LINK_START,
    payload,
  };
}

export function deleteTrackingLinkSuccess(payload) {
  return {
    type: DELETE_TRACKING_LINK_SUCCESS,
    payload,
  };
}

export function deleteTrackingLinkFailure(payload) {
  return {
    type: DELETE_TRACKING_LINK_FAILED,
    payload,
  };
}

// Tracking link actions
export function trackViewTrackingLinkStart(payload) {
  return {
    type: TRACK_VIEW_TRACKING_LINK_START,
    payload,
  };
}

export function trackViewTrackingLinkSuccess(payload) {
  return {
    type: TRACK_VIEW_TRACKING_LINK_SUCCESS,
    payload,
  };
}

export function trackViewTrackingLinkFailure(payload) {
  return {
    type: TRACK_VIEW_TRACKING_LINK_FAILED,
    payload,
  };
}

